import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../services/api';

const BroadcastNotificationModal = ({ show, handleClose }) => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  // Reset form when the modal closes
  const onHide = () => {
    setTitle('');
    setBody('');
    handleClose();
  };

  const handleSendBroadcast = async () => {
    setLoading(true);
    try {
      // Only send title and body now
      const payload = {
        title,
        body,
      };

      // POST /notifications/broadcast
      const response = await api.post('/notifications/broadcast', payload);
      if (response.status === 200) {
        toast.success('Broadcast notification sent successfully!');
        onHide();
      } else {
        toast.error('Failed to send broadcast notification');
      }
    } catch (error) {
      console.error('Error sending broadcast:', error);
      toast.error(error.response?.data?.message || 'Error sending broadcast notification');
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Broadcast Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter notification title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Body</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter notification body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSendBroadcast} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Send'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BroadcastNotificationModal;
